import React, { useEffect, useState } from "react";
import { Tabs, Spin } from "antd";
import aiConsoleService from "services/aiconsoleservice";
import RoleGoalForm from "./RoleGoalForm";
import AgentSettingsForm from "./AgentSettingsForm";
import Observability from "./Observability";
import Prompts from "./Prompts";
import Evaluation from "./Evaluation";
import History from "./History";

const AgentDetail = ({ agentKey, onBack }) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    aiConsoleService
      .getAgent(agentKey)
      .then((res) => {
        setDetail(res?.data ?? null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(load, [agentKey]);

  if (loading) return <div className="p-8 flex justify-center"><Spin /></div>;
  if (!detail) return <div className="p-8 text-center text-gray-400">Could not load this agent.</div>;

  const settings = detail.settings;

  const items = [
    {
      key: "role",
      label: "Role & Goal",
      children: <RoleGoalForm agent={settings} onSaved={load} />,
    },
    {
      key: "settings",
      label: "Settings",
      children: <AgentSettingsForm agent={settings} onSaved={load} />,
    },
    {
      key: "prompts",
      label: "Prompts",
      children: (
        <Prompts agent={settings} promptVersions={detail.prompt_versions} onChanged={load} />
      ),
    },
    {
      key: "history",
      label: "History",
      children: <History agentKey={settings.agent_key} />,
    },
    {
      key: "observability",
      label: "Observability",
      children: <Observability agentData={detail.observability} />,
    },
    {
      key: "evaluation",
      label: "Evaluation",
      children: <Evaluation agent={settings} />,
    },
  ];

  return (
    <div>
      <button
        type="button"
        onClick={onBack}
        className="text-sm text-emerald-600 hover:underline mb-3 focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded"
      >
        Back to agents
      </button>
      <h2 className="text-lg font-semibold text-slate-800 dark:text-white">{settings.display_name}</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{settings.description}</p>
      <Tabs defaultActiveKey="role" items={items} />
    </div>
  );
};

export default AgentDetail;
